module.exports = __webpack_public_path__ + "media/images/landing/icons/facebook-62392c86d1ddb978b0983674626209b7.svg";